import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=c96bc976&scoped=true&"
var script = {}
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=c96bc976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96bc976",
  null
  
)

export default component.exports